import React from "react";
import TubeView from "./TubeView";
import type { TubeConfig } from "../core/types";

interface TubeStackProps {
  tubes: TubeConfig[];
  onPour: (from: number, to: number) => void;
  /** CSS-px width of each tube */
  tubeWidth?: number;
  /** CSS-px height of each tube */
  tubeHeight?: number;
  /** How many columns before wrapping */
  columns?: number;
}

export default function TubeStack({
  tubes,
  onPour,
  tubeWidth  = 45,
  tubeHeight = 140,
  columns    = 6,
}: TubeStackProps) {
  const [selected, setSelected] = React.useState<number|null>(null);

  const total        = tubes.length;
  const rows         = Math.ceil(total/columns);
  const lastRowCount = total % columns || columns;
  const offset       = Math.floor((columns - lastRowCount)/2);

  // gap = 25% of tubeWidth
  const gapPx = tubeWidth * 0.4;

  const handleClick = (i: number) => {
    if (selected === null)       setSelected(i);
    else if (selected === i)     setSelected(null);
    else { onPour(selected, i); setSelected(null); }
  };

  return (
    <div
      className="tube-stack"
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, auto)`,
        gap: `${gapPx}px`,
        width: "max-content",
        margin: "0 auto",
        // justifyContent: "center",
        alignItems: "end",
      }}
    >
      {tubes.map((tube, i) => {
        const row = Math.floor(i/columns);
        const col = i % columns;
        const isLast = row === rows - 1;
        const start = isLast ? col + 1 + offset : undefined;

        return (
          <div
            key={i}
            className={`tube-container ${selected===i?"selected":""}`}
            style={ start ? { gridColumnStart: start } : undefined }
            onClick={() => handleClick(i)}
          >
            <TubeView
              segments={tube.segments}
              isSelected={selected===i}
              width={tubeWidth}
              height={tubeHeight}
            />
          </div>
        );
      })}
    </div>
  );
}
